import * as React from 'react'
import { useLocation } from 'react-router-dom'

import { decodeQueryString } from '../../app/queryString'

export function useCheckNonIdeaChartMissingConfig() {
  const location = useLocation()

  React.useEffect(() => {
    // Navigation (back/forward) from nonexisting idea page doesn't fully reload the page
    // So if we're on non idea page and have still isIdeaNotFoundPage flag we want to reload the page
    const { i } = decodeQueryString(location.search)
    if (!i && window.isIdeaNotFoundPage) {
      window.location.reload()
    }
  }, [location.search])
}
